<script setup lang="ts">
import Joi from 'joi'
import type { FormErrorEvent } from '#ui/types'
import type { Search } from "~/common/types/types";
import EditSearch from './EditSearch.vue';
import { isEntityId } from '../util';

const schema = Joi.object({
  _id: Joi.custom(isEntityId),
  name: Joi.string().required(),
  status: Joi.string().allow(''),
  threshold: Joi.number().required(),
  clientId: Joi.custom(isEntityId),
  created: Joi.date().required(),
  updated: Joi.date(),
  description: Joi.string().allow(''),
  results: Joi.optional()
})

const search = defineModel({
  required: true,
  type: Object as PropType<Search>   
})

const emit = defineEmits(['submitted'])

async function onSubmit () {
  emit('submitted', {
    ...search.value, 
  });
}

async function onError (event: FormErrorEvent) {
  console.log(event.errors)
}

</script>

<template>
  <UForm :schema="schema" :state="search" class="space-y-4" @submit="onSubmit" @error="onError" >
    <EditSearch v-model="search" />    
    <UButton type="submit" class="mt-3">
      Update Search
    </UButton>
  </UForm>    
</template>